module.exports = __webpack_public_path__ + "img/76129.3267cfa2.svg";